import { ReactElement } from 'react';
import { Tooltip } from '@mui/joy';

import './PageRow.less';

import { CustomTagSelector } from '../../../tagSelector/CustomTagSelector';
import { Page, addTag, removeTag, unstash } from '../../../../db/pages';
import { useAppDispatch } from '../../../../store/hooks';
import { focusTag, setNotification, setTabIndex } from '../../../../store/uiSlice';
import { TagAttachment } from '../../../tagSelector/tag_utils';
import React from 'react';
import { useLiveQuery } from 'dexie-react-hooks';
import { fetchTagNames } from '../../../../db/tags';
import { faFlag as fasFlag } from '@fortawesome/free-solid-svg-icons';
import { faCartPlus as fasCartPlus } from '@fortawesome/free-solid-svg-icons';
import { faFlag as farFlag } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FlagTag, StashTag, SystemTags } from '../../../../db/constants';
import { Tab } from '../../../../store/windowsSlice';
import { closeTab, hasUnsavedChanges } from '../../../../chrome/chromeActions';
import { setSimilarUrlsAsync } from '../../../../store/windowsSlice';

interface PageTagsProps {
  page: Page;
  tabs: Tab[];
}

const PageTags = React.memo(({ page, tabs }: PageTagsProps): ReactElement => {
  // TODO: Factor out options again, so that the liveQuery is in a wrapper component
  const options = useLiveQuery(fetchTagNames) as string[];

  const dispatch = useAppDispatch();

  const humanTags: TagAttachment[] = page.humanTags.map((tag) => {
    return {
      name: tag,
      humanEdit: true,
      inferenceStrength: 1,
      proportion: 1,
    };
  });
  const autoTags: TagAttachment[] = page.autoTags?.map((autotag) => {
    return {
      name: autotag.name,
      humanEdit: false,
      inferenceStrength: autotag.inferenceStrength,
      proportion: 1,
    };
  });
  const isFlag = page.humanTags.includes(FlagTag);
  const isStash = page.humanTags.includes(StashTag);

  return (
    <>
      <CustomTagSelector
        attachments={humanTags
          .concat(autoTags)
          .filter(Boolean)
          .filter((tag) => !SystemTags.includes(tag.name))}
        onAdd={(value) => {
          if (value != '') {
            addTag([page.nurl.normalized], value);
            dispatch(setSimilarUrlsAsync());
          }
        }}
        onDelete={(value) => {
          if (value != '') {
            removeTag([page.nurl.normalized], value);
            dispatch(setSimilarUrlsAsync());
          }
        }}
        onClickTag={(value) => {}}
        onDoubleClickTag={(value) => {
          dispatch(focusTag({ tag: value }));
          dispatch(setTabIndex(1));
        }}
        options={options}
      />

      <div className="pagerow__pageTags">
        {isFlag ? (
          <Tooltip title="Unflag" placement="top" sx={{ zIndex: 99999 }}>
            <FontAwesomeIcon
                className="pagerow__tagicon"
                icon={fasFlag}
                onClick={() => {
                  removeTag([page.nurl.normalized], FlagTag);
                  dispatch(setSimilarUrlsAsync());
                }}
                color="orange"
            />
          </Tooltip>
        ) : (
          <Tooltip title="Flag" placement="top" sx={{ zIndex: 99999 }}>
            <FontAwesomeIcon
                className="pagerow__tagicon pagerow__hoverbuttons"
                icon={farFlag}
                onClick={() => {
                  addTag([page.nurl.normalized], FlagTag);
                  dispatch(setSimilarUrlsAsync());
                }}
                color="rgb(90,90,90)" // bghighlighted
            />
          </Tooltip>
        )}

        {isStash ? (
          <Tooltip title="Unstash" placement="top" sx={{ zIndex: 99999 }}>
            <FontAwesomeIcon
                className="pagerow__tagicon"
                icon={fasCartPlus}
                onClick={() => {
                  unstash([page.nurl.normalized]);
                  dispatch(setSimilarUrlsAsync());
                }}
                color="blue"
            />
          </Tooltip>
        ) : (
          <Tooltip title="Stash" placement="top" sx={{ zIndex: 99999 }}>
            <FontAwesomeIcon
                className="pagerow__tagicon pagerow__hoverbuttons"
                icon={fasCartPlus}
                onClick={() => {
                  void (async () => {
                    let skipped = false;
                    for (const tab of tabs) {
                      if (tab.id != null && await hasUnsavedChanges(tab.id)) {
                        skipped = true;
                      } else {
                        closeTab(tab.id);
                      }
                    }
                    if (skipped) {
                      dispatch(setNotification('Tab not closed — unsaved changes'));
                    }
                    // DB stash proceeds regardless of whether the tab was closed.
                    addTag([page.nurl.normalized], StashTag);
                    dispatch(setSimilarUrlsAsync());
                  })();
                }}
                color="rgb(90,90,90)" // bghighlighted
            />
          </Tooltip>
        )}

      </div>
    </>
  );
});

export default PageTags;
